import React, { useState, useEffect } from 'react';
import {
    Widget,
    GridView,
    SimpleView,
    FormInput,
    MasterDetailForm,
    FormSubmitButton,
    FormatText,
    FormSwitch,
    FormNumber,
} from '@digital/ui';
import { Form, Input, Radio } from 'antd';
import { Permissao, PermissaoPost } from '@app/api/permissao';
import { ContratadoAno, CreateContratadoAnoAnoReferencia } from '@app/api/contratadoAno';
import { adcionarAnoADistribuirByProjetoIdAndYear } from '@app/api/routines';


interface CadastroPermissaoProps {

}

const CadastroPermissao = (props: CadastroPermissaoProps) => {

    const { } = [props];

    const harPostPermissao = (values: Permissao) => {
        return PermissaoPost(values)
    }

    const harPostCreateContratadoAnoAno = (values: ContratadoAno) => {
        return CreateContratadoAnoAnoReferencia(values)
    }

    const harAdcionarAnoADistribuirByProjetoIdAndYear = (values: any) => {
        return adcionarAnoADistribuirByProjetoIdAndYear(values)
    }


    return (
        <SimpleView >
            <GridView
                noform>
                <MasterDetailForm
                    initialValues={{
                        codigo: ''
                    }}
                    onSubmit={values => {
                        harPostPermissao(values as Permissao);
                    }}>
                    <Widget
                        title={'Cadatro de Permissões'}
                        actions={[
                            (
                                <FormSubmitButton type="primary">
                                    <FormatText id="ui.commons.save" uppercase />
                                </FormSubmitButton>
                            ),
                        ]}>

                        <FormInput
                            label="Código"
                            name="codigo"
                        />

                    </Widget>
                </MasterDetailForm>


                <MasterDetailForm
                    initialValues={{
                        requisicaoCompraSeqId: '',
                        ano: '',
                        semVinculoComOi: false
                    }}
                    onSubmit={values => {
                        harPostCreateContratadoAnoAno(values as ContratadoAno);
                    }}>
                    <Widget
                        title={'Cadatro de Contratado Ano'}
                        actions={[
                            (
                                <FormSubmitButton type="primary">
                                    <FormatText id="ui.commons.save" uppercase />
                                </FormSubmitButton>
                            ),
                        ]}>

                        <FormInput
                            label="RequisicaoCompraSeqId"
                            name="requisicaoCompraSeqId"
                            required
                        />

                        <FormNumber
                            label="Ano"
                            name="ano"
                            required
                        />

                        <FormSwitch
                            label="SemVinculoComOi"
                            name="semVinculoComOi"
                        />

                    </Widget>
                </MasterDetailForm>


                <MasterDetailForm
                    initialValues={{
                        codigoProjeto: '',
                        ano: '',
                    }}
                    onSubmit={values => {
                        harAdcionarAnoADistribuirByProjetoIdAndYear(values);
                    }}>
                    <Widget
                        title={'Incluir Ano a Distribuir do Projeto'}
                        actions={[
                            (
                                <FormSubmitButton type="primary">
                                    <FormatText id="ui.commons.save" uppercase />
                                </FormSubmitButton>
                            ),
                        ]}>

                        <FormInput
                            label="Código do Projeto"
                            name="codigo"
                            required
                        />

                        <FormNumber
                            label="Ano"
                            name="ano"
                            required
                        />


                    </Widget>
                </MasterDetailForm>

            </GridView>
        </SimpleView>

    );



}

export default CadastroPermissao;